import { Box, InputLabel, Typography, FormControl, TextField } from '@mui/material';
import PropTypes from 'prop-types';

const TextInput = ({
  label,
  sublabel = null,
  value,
  onChange,
  InputProps,
  errorMessage,
  sx = {},
  ...props
}) => (
  <FormControl fullWidth>
    <Box>
      <InputLabel sx={{ position: 'relative', transform: 'unset', color: 'gray.700' }}>
        {typeof label === 'string' ? (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '1rem',
              lineHeight: '100%',
              letterSpacing: '0px',
            }}
          >
            {label}
          </Typography>
        ) : (
          label
        )}
      </InputLabel>
      {sublabel}
      <Box>
        <TextField
          value={value}
          onChange={onChange}
          sx={{ ...sx, py: '8px' }}
          InputProps={{
            sx: {
              height: '33px',
              borderRadius: '3px',
              ...(InputProps?.sx || {}),
            },
            ...(InputProps || {}),
          }}
          error={Boolean(errorMessage)}
          {...props}
          fullWidth
        />
      </Box>
      {errorMessage && (
        <Typography fontSize="12px" color="error">
          {errorMessage}
        </Typography>
      )}
    </Box>
  </FormControl>
);

TextInput.displayName = 'TextInput';

TextInput.propTypes = {
  label: PropTypes.node,
  sublabel: PropTypes.node,
  value: PropTypes.string,
  onChange: PropTypes.func,
  sx: PropTypes.object,
};

export default TextInput;
